<template>
    <div class="table-loader-custom-h">
      <div class="container p-0">
        <div class="container p-0">
          <div class="mchp-section-container">
            <div class="section-grouping mchp-section-container-full-width">
              <div class="section-title row row-custom-dash p-0 g-0">
                <div class="tableWrapper">
                  <table class="table">
                    <tbody>
                      <tr v-for="rowIndex in rowCount" :key="rowIndex" role="row">
                        <td class="loading">
                          <div class="bar"></div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    export default {
      name: 'ContentLoader',
      props: ['rowCount']
    }
  </script>
  <style lang="scss" scoped>
  .table-loader-custom-h {
    overflow: hidden;
  }
    @keyframes loading {
      40% {
          background-position:
              100% 0;
      }
      100% {
          background-position:
              100% 0;
      }
  }
  
  .tableWrapper {
    background-color: #fff;
    width: 100%;
    
    .table {
      height: 100%;
      margin: 0 auto;
      text-align: left;
      border-spacing: 0;

      tbody {
        td {
          padding: 20px 0;
          min-width: 150px;
          border: none;
          @media (max-width: 991px) {
            min-width: 20%;
          }
          span {
              color: #FEFEFE;
          }
  
          &:last-child {
              border-radius: 0 8px 8px 0;
          }
        }
      }
    }
    .loading {
      position: relative;
      
      .bar {
        background-color: #E7E7E7;
        height: 24px;
        min-height: 24px;   
        border-radius: 7px;
        width: 100%;
      }
  
      &:after {
          position: absolute;
          transform: translateY(-50%);
          top: 50%;
          left: 0;
          content: "";
          display: block;
          width: 100%;
          height: 24px;
          background-image: linear-gradient( 100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 80% );
          background-size: 200px 24px;
          background-position: -100px 0;
          background-repeat: no-repeat;
          animation: loading 1s infinite;
      }
    }
  }
  </style>
  